import Vue from 'vue'
import Router from 'vue-router'


const Login = () => import(/* webpackChunkName: "login_welcome" */ '@/views/Login.vue')

const layouts = () => import(/* webpackChunkName: "home_welcome" */ '@/layouts')

const Role = () => import(/* webpackChunkName: "Users_Rights_Roles" */ '@/views/rights/role/Role.vue')

const Menu = () => import(/* webpackChunkName: "Users_Rights_Menu" */ '@/views/rights/menu/Menu.vue')

const Dept = () => import(/* webpackChunkName: "Users_Rights_Dept" */ '@/views/rights/dept/Dept.vue')

const Rule = () => import(/* webpackChunkName: "Users_Rights_WebSet" */ '@/views/system/rule/webSet.vue')

const Board = () => import(/* webpackChunkName: "home_board" */ '@/views/board/Board.vue')

const User = () => import(/* webpackChunkName: "Order_User" */ '@/views/rights/user/User.vue')

const Syspost = () => import(/* webpackChunkName: "Order_SysPost" */ '@/views/rights/syspost/Syspost')

const CustomerSer  = () => import(/* webpackChunkName: "Order_customerSer" */ '@/views/monitoring/customerSer/customerSer')
const MessageLog  = () => import(/* webpackChunkName: "Order_MessageLog" */ '@/views/monitoring/messageLog/MessageLog')
const Feedback  = () => import(/* webpackChunkName: "Order_Feedback" */ '@/views/monitoring/feedback/Feedback')
const Translate  = () => import(/* webpackChunkName: "Order_Translate" */ '@/views/monitoring/translate/Translate')
const TimedTask  = () => import(/* webpackChunkName: "Order_TimedTask" */ '@/views/monitoring/timedTask/Timedtask')
const Evaluate  = () => import(/* webpackChunkName: "Monitoring_Evaluate" */ '@/views/monitoring/evaluate/Evaluate')
const AllEvaluate  = () => import(/* webpackChunkName: "Assessment_AllEvaluate" */ '@/views/assessment/allEvaluate')
const Transfer  = () => import(/* webpackChunkName: "Assessment_Transfer" */ '@/views/assessment/transfer')



Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/', redirect: '/board' },
    { path: '/login', component: Login },
    {
      path: '/home',
      component: layouts,
      redirect: '/board',
      children: [
        { path: '/role', component: Role },
        { path: '/menuList', component: Menu },
        { path: '/dept', component: Dept },
        { path: '/board', component: Board },
        { path: '/user', component: User },
        { path: '/post', component: Syspost },
        { path: '/customerSer', component: CustomerSer },
        { path: '/messageLog', component: MessageLog },
        { path: '/feedback', component: Feedback },
        { path: '/translate', component: Translate },
        { path: '/job', component: TimedTask },
        { path: '/webSet', component: Rule },
        { path: '/evaluate', component: Evaluate },
        { path: '/allEvaluate', component: AllEvaluate },
        { path: '/transfer', component: Transfer },
        { path: '/liveTransfer', component: () => import(/* webpackChunkName: "Assessment_LiveTransfer" */ '@/views/assessment/liveTransfer') },
      ]
    },
    {
      path: '/customer',
      component: layouts,
      redirect: '/post',
      children: [
        {
          path: 'user-tag',
          name: 'CustomerUserTag',
          component: () => import(/* webpackChunkName: "CustomerUserTag" */ '@/views/customer/userTag')
        },
        {
          path: 'user-quick-reply',
          name: 'CustomerQuickReply',
          component: () => import(/* webpackChunkName: "CustomerQuickReply" */ '@/views/customer/quickReply')
        },
        {
          path: 'qrcode-config',
          name: 'QrCodeConfig',
          component: () => import(/* webpackChunkName: "customer_qrCodeConfig" */ '@/views/customer/qrCodeConfig')
        },
        {
          path: 'mapping',
          name: 'customerMapping',
          component: () => import(/* webpackChunkName: "customerMapping" */ '@/views/customer/mapping')
        }
      ]
    },
    {
      path: '/system',
      component: layouts,
      redirect: '/post',
      children: [
        {
          path: 'updatePwd',
          name: 'SystemUpdatePwd',
          component: () => import(/* webpackChunkName: "SystemUpdatePwd" */ '@/views/system/password/updatePwd')
        },
        {
          path: 'resetPwd',
          name: 'SystemResetPwd',
          component: () => import(/* webpackChunkName: "SystemResetPwd" */ '@/views/system/password/resetPwd')
        }
      ]
    },
    {
      path: '/assessment',
      component: layouts,
      children: [
        {
          path: 'shareList',
          name: 'AssessmentShareList',
          component: () => import(/* webpackChunkName: "AssessmentShareList" */ '@/views/assessment/shareList')
        },
        {
          path: 'weChatInfoList',
          name: 'AssessmentWeChatInfoList',
          component: () => import(/* webpackChunkName: "AssessmentWeChatInfoList" */ '@/views/assessment/weChatInfoList')
        }
      ]
    }
  ]
})

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // to 将要访问的路径
  // from 代表从哪个路径跳转而来
  // next 是一个函数，表示放行
  //     next()  放行    next('/login')  强制跳转

  if (to.path === '/login') return next()
  // 获取token
  const tokenStr = localStorage.getItem('token')
  if (!tokenStr) return next('/login')
  next()
})

export default router
